export default class LogMsgConstants {
  // スキャン機能のエラーコードとメッセージ =====================================================================
  /** まとめ投入による過剰投入エラーが発生した際にログメッセージ。*/
  static FUNC_SCAN_CONFIRM_TASK_EXCESS_ENTRY_MULTI_SORT_LOG_MSG =
    '【{0}】対象のスキャンコード「{1}」で仕分けを行いましたが、投入数の上限を超えたか仕分けが完了していたため過剰投入エラーとしました。リクエスト情報：{2}';
  /** 手仕分けによる過剰投入エラーが発生した際にログメッセージ。*/
  static FUNC_SCAN_CONFIRM_TASK_EXCESS_ENTRY_MANUAL_SORT_LOG_MSG =
    '【{0}】対象のスキャンコード「{1}」で仕分けを行いましたが、投入数の上限を超えたか仕分けが完了していたため過剰投入エラーとしました。リクエスト情報：{2}';
  /** RFIDスキャンが一致しない場合のログメッセージ。*/
  static FUNC_SCAN_CONFIRM_NON_MATCH_RFID_SINGLE_SORT_LOG_MSG =
    '【{0}】RFIDが読み取れませんでした。再度RFID読取機器にかざしてください。読み取りRFID={1}';
}
